var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47607 15C2.65107 8.6 8.25982 3.75 14.9998 3.75C21.7398 3.75 27.3473 8.6 28.5236 15C27.3486 21.4 21.7398 26.25 14.9998 26.25C8.25982 26.25 2.65232 21.4 1.47607 15ZM14.9998 21.25C16.6574 21.25 18.2471 20.5915 19.4192 19.4194C20.5913 18.2473 21.2498 16.6576 21.2498 15C21.2498 13.3424 20.5913 11.7527 19.4192 10.5806C18.2471 9.40848 16.6574 8.75 14.9998 8.75C13.3422 8.75 11.7525 9.40848 10.5804 10.5806C9.4083 11.7527 8.74982 13.3424 8.74982 15C8.74982 16.6576 9.4083 18.2473 10.5804 19.4194C11.7525 20.5915 13.3422 21.25 14.9998 21.25ZM14.9998 18.75C14.0053 18.75 13.0514 18.3549 12.3482 17.6517C11.6449 16.9484 11.2498 15.9946 11.2498 15C11.2498 14.0054 11.6449 13.0516 12.3482 12.3483C13.0514 11.6451 14.0053 11.25 14.9998 11.25C15.9944 11.25 16.9482 11.6451 17.6515 12.3483C18.3547 13.0516 18.7498 14.0054 18.7498 15C18.7498 15.9946 18.3547 16.9484 17.6515 17.6517C16.9482 18.3549 15.9944 18.75 14.9998 18.75Z",
    fill: "#2D3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewTest);
export default __webpack_public_path__ + "static/media/View_Test.04d9ee68f3a3e5eddd4e2357e12f7fee.svg";
export { ForwardRef as ReactComponent };